import hanami1 from "./hanami (1).png";
import hanami2 from "./hanami (2).png";
import hanami3 from "./3.png";
import hanami4 from "./4.png";
import hanami5 from "./5.png";
import hanami6 from "./6.png";

const hanamiImages = [hanami1, hanami2, hanami3, hanami4, hanami5, hanami6];

export default hanamiImages;
